import { ApiClientBase } from "api/ApiClientBase";

class TrainingPlansApiClient extends ApiClientBase {
    getSchoolTrainingPlans(schoolId, payload) {
        return this.post(`api/v1/training-plan/school/${schoolId}/groups`, payload).then(
            (r) => r.data,
        );
    }

    getRegionTrainingPlans(regionId, payload) {
        return this.post(`/api/v1/training-plan/region/${regionId}/schools`, payload).then(
            (r) => r.data,
        );
    }

    getMunicipalityTrainingPlans(municipalityId, payload) {
        return this.post(
            `/api/v1/training-plan/municipality/${municipalityId}/schools`,
            payload,
        ).then((r) => r.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new TrainingPlansApiClient();
